module.exports = __webpack_public_path__ + "static/media/whitebg.8b9e8474.jpg";